export const MedicalSpeciality = {
  GASTROENTEROLOGY: 'Gastroenterology',
  PULMONOLOGY: 'Pulmonology'
};

export const MEDICAL_SPECIALITIES = Object.values(MedicalSpeciality);

export default MedicalSpeciality;
